export const REGISTRO_CHECK = 'RegistroCheck'
export const ASISTENCIA = 'Asistencia'

const tiposEvaluacion = [
    { label: REGISTRO_CHECK, value: REGISTRO_CHECK },
    { label: ASISTENCIA, value: ASISTENCIA },
];

export default tiposEvaluacion
